export default __webpack_public_path__ + "static/media/loc.474a2188.svg";